import styled from "styled-components";

export const ButtonContainer = styled.div`
display: flex;
justify-content: flex-end;
gap: 10px;
margin-top: 20px;
`;